import React from 'react';
import CrearNoticiaAvanzada from './CrearNoticiaAvanzada';

// Wrapper que reutiliza el editor avanzado también para editar
const EditarNoticia = () => <CrearNoticiaAvanzada />;

export default EditarNoticia;
